/// <amd-module name="Agile/Common/Redux/HubTeam/HubTeamContracts" />
import { ITeam } from "Agile/Contracts/Common";

export interface IHubTeamAwareState {
    hubteamState: IHubTeamState;
}

export interface IHubTeamState {
    team?: ITeam;
}
